import React from 'react';
import { useSelector } from 'react-redux';
import Slider from 'react-slick';
import { RootState } from '../../../app/store';
import { classNames } from '../../../utils/classNames';
import { useGetCardsQuery } from '../../../store/chatbox/chatboxApi';
import Loading from '../../../shared/Loading';

const StayUpdated = () => {
	const {data, isLoading} = useGetCardsQuery()

	const features = useSelector(
			(state: RootState) => state.features
		  );
		  
	const settings = {
		dots: false,
		arrows: false,
		infinite: true,
		speed: 8000,
		slidesToShow: 4,
		slidesToScroll: 1,
		autoplay: features.newsSection,
		autoplaySpeed: 0,
		cssEase: 'linear',
		responsive: [
			{
				breakpoint: 1600,
				settings: {
				  slidesToShow: 3,
				  slidesToScroll: 1,
				  infinite: true,
				}
			  },
			{
			  breakpoint: 767,
			  settings: {
				slidesToShow: 1,
				slidesToScroll: 1,
				infinite: true,
			  }
			},
		]
	  };
	return (
		<div className={classNames('relative my-8 max-w-[99%]', features.newsSection ? '' : 'opacity-10')}>
			{!features.newsSection && <div className='absolute top-0 left-0 w-full h-full z-10' />}
			{isLoading && <Loading />}
			<Slider {...settings}>
				{data?.map(stay => (
					<div key={stay.title} className='px-1'>
						<div  className='rounded-xl border-2 p-4 flex flex-wrap min-h-32 items-center' style={{borderColor: stay.color}}>
							{stay.image ? <img src={stay.image} className='w-12 h-12 rounded-full object-cover' alt={stay.title} /> :
								<div className='w-12 h-12' />
							}
							<div className='ml-3 w-9/12'>
								<h4 className='font-semibold text-base mb-0.5 text-gray-900 dark:text-primary-darkMode'>{stay.title}</h4>
								<p className='font-normal text-[13px] text-gray-900 elipses-2 dark:text-primary-darkMode'>{stay.subtitle}</p>
							</div>
						</div>
					</div>
				))}
			</Slider>
		</div>
	)
}

export default StayUpdated;